// Export Excel di Worklogs V2: stesse colonne e stesso nome file delle pagine classiche, per ambito.
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const hours = (minutes) => (Number(minutes) ? Math.round((Number(minutes) / 60) * 100) / 100 : 0);
const dateCells = (w) => {
  const [year = '', month = ''] = w.dateKey ? w.dateKey.split('-') : [];
  return { Date: w.dateKey || '', Month: month, Year: year };
};

const COLUMNS = {
  mine: (w) => ({
    Project: w.project_name,
    'Ticket ID': w.ticket_id,
    ...dateCells(w),
    'Effort in minutes': w.effort,
    Activity: w.activity_name,
    'Effort Type': w.effort_type_name,
    Description: w.description,
  }),
  projects: (w, projectById) => ({
    Project: w.project_name,
    User: w.user_name,
    Team: w.team_name,
    'Ticket ID': w.ticket_id,
    ...dateCells(w),
    'Effort (min)': Number(w.effort) || 0,
    'Effort (hours)': hours(w.effort),
    Activity: w.activity_name,
    'Effort Type': w.effort_type_name,
    Description: w.description,
    'Project Code': w.project_code || projectById.get(w.project_id)?.project_code || '',
  }),
  people: (w) => ({
    'People Manager': w.people_manager_name,
    User: w.user_name,
    Project: w.project_name,
    Team: w.team_name,
    'Ticket ID': w.ticket_id,
    ...dateCells(w),
    'Effort (min)': Number(w.effort) || 0,
    'Effort (hours)': hours(w.effort),
    Activity: w.activity_name,
    'Effort Type': w.effort_type_name,
    Description: w.description,
  }),
};

const ddmmyyyy = (key) => (key ? key.split('-').reverse().join('') : '');
const clean = (name) => String(name || '').replace(/[^a-zA-Z0-9]/g, '_');

/**
 * Scarica i worklog mostrati (già filtrati).
 * label: nome del progetto o della persona scelti, oppure "Multiple_Projects" / "Multiple_Users" (vuoto = nessuno).
 */
export function downloadWorklogsWorkbook({ scope, rows, from, to, label, projects = [] }) {
  const projectById = new Map(projects.map((p) => [p.id, p]));
  const sheet = XLSX.utils.json_to_sheet(rows.map((w) => COLUMNS[scope](w, projectById)));
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, 'Worklogs');
  const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const range = `${ddmmyyyy(from)}-${ddmmyyyy(to)}`;
  const fileName = label ? `worklogs_${clean(label)}_${range}` : `Worklogs_${range}`;
  saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
}
